export const emailRegex = (input) => {
  const regex = /^[a-z0-9]+[a-z0-9_]*(?:(\_[a-z0-9]*)*(\-[a-z0-9-]+)*(\.[a-z0-9]+)*)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[\-a-z0-9]+)*(\.[a-z]{2,})+$/ // eslint-disable-line
  return regex.test(String(input).toLowerCase())
}

export const passwordRegex = (input) => {
  const minChars = 8
  const maxChars = 128
  if (input.length < minChars) return false
  if (input.length > maxChars) return false
  return true
}

const COUNTRY_CODES = {
  GB: '+44', // UK
  IE: '+353', // Ireland
  PK: '+92', // Pakistan
  IN: '+91', // India
  PL: '+48', // Poland
}

export const phoneNumberRegex = (phoneNumber, countryCode) => {
  let phoneNumberLength = phoneNumber.length
  let isValidPhoneNumber
  let validatedPhoneNumber = phoneNumber
  switch (countryCode) {
    case COUNTRY_CODES.GB:
      if ((phoneNumberLength === 9 || phoneNumberLength === 10) && phoneNumber.charAt(0) !== '0') {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      if (validatedPhoneNumber.substring(0, 2) !== '01') {
        isValidPhoneNumber = phoneNumberLength === 11
      } else {
        isValidPhoneNumber = phoneNumberLength === 11 || phoneNumberLength === 10
      }
      return isValidPhoneNumber
    case COUNTRY_CODES.IE:
      if (
        validatedPhoneNumber.charAt(0) !== '0' &&
        phoneNumberLength >= 6 &&
        phoneNumberLength <= 10
      ) {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      if (validatedPhoneNumber.charAt(0) === '0' && validatedPhoneNumber.charAt(1) !== '8') {
        isValidPhoneNumber = phoneNumberLength >= 7 && phoneNumberLength <= 11
      } else if (validatedPhoneNumber.substring(0, 2) === '08') {
        isValidPhoneNumber = phoneNumberLength === 10
      }
      return isValidPhoneNumber
    case COUNTRY_CODES.PK:
      if (phoneNumberLength === 10 && phoneNumber.charAt(0) !== '0') {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 11
      return isValidPhoneNumber
    case COUNTRY_CODES.IN:
      validatedPhoneNumber = phoneNumber.substring(0, 10)
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 10
      return isValidPhoneNumber
    case COUNTRY_CODES.PL:
      validatedPhoneNumber = phoneNumber.substring(0, 9)
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 9
      return isValidPhoneNumber
    default:
      validatedPhoneNumber = phoneNumber.substring(0, 12)
      isValidPhoneNumber = validatedPhoneNumber.length >= 6 && validatedPhoneNumber.length <= 12
      return isValidPhoneNumber
  }
}

export const postcodeRegex = (input) => {
  const regex = /^\s*[A-Z]{1,2}[0-9R][0-9A-Z]? {0,1}[0-9][ABD-HJLNP-UW-Z]{2}\s*$/i // eslint-disable-line
  return regex.test(String(input).toLowerCase())
}

export const walmartNumberRegex = (input) => {
  const regex = /^[\d]{10}$/ // eslint-disable-line
  return regex.test(String(input))
}

export const colleagueDiscountNumberRegex = (input) => {
  const regex = /^[0-9 ]{16}$/ // eslint-disable-line
  return regex.test(String(input))
}
